import { whatsappLink, PHONE } from "@/lib/api";
import { useQuote } from "@/context/QuoteContext";
import { useLang } from "@/i18n/LanguageContext";
import { Phone, MessageCircle, MessageSquareText } from "lucide-react";

const TEL = PHONE.replace(/[^+\d]/g, "");

export default function FloatingActions() {
  const { openQuote } = useQuote();
  const { t } = useLang();
  return (
    <div className="hidden md:flex fixed bottom-5 right-5 z-50 flex-col items-end gap-3">
      <button
        onClick={() => openQuote({ type: "call" })}
        className="flex items-center gap-2 rounded-full bg-white border border-border text-secondary px-4 py-2.5 shadow-md hover:shadow-lg transition-all text-sm font-medium"
        data-testid="floating-book-call-btn"
      >
        <Phone className="w-4 h-4" /> {t("common.bookCall")}
      </button>
      <a
        href={`sms:${TEL}`}
        className="flex items-center gap-2 rounded-full bg-secondary text-white px-4 py-2.5 shadow-md hover:bg-secondary/90 transition-all text-sm font-medium"
        data-testid="floating-text-btn"
      >
        <MessageSquareText className="w-4 h-4" /> {t("common.textUs")}
      </a>
      <a
        href={whatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        style={{ backgroundColor: "#25D366" }}
        className="flex items-center gap-2 rounded-full text-white pl-4 pr-5 py-3 shadow-xl hover:opacity-90 transition-all hover:scale-105 animate-float"
        data-testid="floating-whatsapp-btn"
      >
        <MessageCircle className="w-5 h-5" /> <span className="font-semibold">WhatsApp</span>
      </a>
    </div>
  );
}
